module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Rocket Jack.b3ba6872.webp";